export default __webpack_public_path__ + "static/diversity-b406fa21cc43148029d542d1078e48a1.png";